import { render, staticRenderFns } from "./Expiration.vue?vue&type=template&id=db72759c&lang=pug"
import script from "./Expiration.vue?vue&type=script&lang=coffee"
export * from "./Expiration.vue?vue&type=script&lang=coffee"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports